module.exports = __webpack_public_path__ + "static/media/i-ending inkjekjønn.0d7928f4.mp3";